import type { NuxtApp } from "#app";

export type FeatureName = "portfolio" | "portfolioDataWarehouse" | "rentalData" | "balanceKeyFigures" | "arrearsBeta" | "rentalBreakdown" | "canvasReports" | "canvasEdit" | "reports" | "userPreferences";

export type FeatureFlag = {
  name: FeatureName;
  active: boolean;
  routes: string[];
};

function isFeature(app: NuxtApp) {
  return app.$config.public.buildVariant === "feature";
}

function isDev(app: NuxtApp) {
  return app.$config.public.buildVariant === "dev";
}

export const featureFlags: (app: NuxtApp) => FeatureFlag[] = (app) => [
  {
    name: "rentalData",
    active: true,
    routes: ["explore-property-id-rental-levels"],
  },
  {
    name: "portfolio",
    active: true,
    routes: ["portfolio", "portfolio-properties", "portfolio-tenancies"],
  },
  {
    name: "portfolioDataWarehouse",
    active: isDev(app) || isFeature(app),
    routes: ["datawarehouse"],
  },
  {
    name: "balanceKeyFigures",
    active: isDev(app) || isFeature(app),
    routes: [],
  },
  {
    name: "arrearsBeta",
    active: true,
    routes: [],
  },
  {
    name: "rentalBreakdown",
    active: true,
    routes: [],
  },
  {
    name: "canvasReports",
    active: isDev(app) || isFeature(app),
    routes: ["canvas-reports"],
  },
  {
    name: "canvasEdit",
    active: isDev(app) || isFeature(app),
    routes: [],
  },
  {
    name: "reports",
    active: isDev(app) || isFeature(app),
    routes: ["reports"],
  },
  {
    name: "userPreferences",
    active: isDev(app) || isFeature(app),
    routes: [],
  },
];
